function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import Constants from "expo-constants";
import * as Device from "expo-device";
import * as Notifications from "expo-notifications";
import { Platform } from "react-native";
import { graphql } from "@oui/lib/src/graphql/tada";
import { getInstallationIDAsync } from "./getInstallationIDAsync";
import Sentry from "../sentry";
export var SetPushTokenMutation = graphql("\n  mutation SetPushToken(\n    $deviceID: UUID!\n    $platform: String!\n    $platformPushToken: String\n    $expoPushToken: String\n  ) {\n    setDevice(\n      device: {\n        installationID: $deviceID\n        platform: $platform\n        pushToken: $platformPushToken\n        expoToken: $expoPushToken\n      }\n    )\n  }\n");
export function setDeviceInfo(client) {
    return _setDeviceInfo.apply(this, arguments);
}
function _setDeviceInfo() {
    _setDeviceInfo = _async_to_generator(function(client) {
        var status, _tmp, installationID, expoPushToken, platformPushToken, _Constants_expoConfig_extra, _Constants_expoConfig, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(Platform.OS === 'web' || !Device.isDevice)) return [
                        3,
                        1
                    ];
                    _tmp = {
                        status: 'denied'
                    } // currently don't support notifications on web
                    ;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        Notifications.getPermissionsAsync()
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    status = _tmp.status;
                    return [
                        4,
                        getInstallationIDAsync()
                    ];
                case 4:
                    installationID = _state.sent();
                    if (!(status === 'granted')) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        Notifications.getExpoPushTokenAsync({
                            projectId: (_Constants_expoConfig = Constants.expoConfig) === null || _Constants_expoConfig === void 0 ? void 0 : (_Constants_expoConfig_extra = _Constants_expoConfig.extra) === null || _Constants_expoConfig_extra === void 0 ? void 0 : _Constants_expoConfig_extra.eas.projectId
                        })
                    ];
                case 5:
                    expoPushToken = _state.sent();
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        Notifications.getDevicePushTokenAsync()
                    ];
                case 7:
                    platformPushToken = _state.sent().data;
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 9:
                    client.mutate({
                        mutation: SetPushTokenMutation,
                        variables: {
                            deviceID: installationID,
                            platform: Platform.OS,
                            expoPushToken: expoPushToken === null || expoPushToken === void 0 ? void 0 : expoPushToken.data,
                            platformPushToken: platformPushToken
                        }
                    }).catch(function(e) {
                        return Sentry.captureException(e);
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _setDeviceInfo.apply(this, arguments);
}
